/*eslint-disable*/
import { isEmpty, compose, remove, isNil, either, complement } from 'ramda'

// helper1
function isArraylike(obj) {
  var length = (obj = Object(obj)).length,
    type = typeof obj;

  if (type === "function") {
    return false;
  }

  if (obj.nodeType === 1 && length) {
    return true;
  }

  return type === "array" || length === 0 ||
    typeof length === "number" && length > 0 && (length - 1) in obj;
}
// helper2
function each (obj, callback, args) {
  let value
  let i = 0
  let length = obj.length
  let isArray = isArraylike(obj)

  if (args) {
      if (isArray) {
          for (; i < length; i++) {
              value = callback.apply(obj[i], args);

              if (value === false) {
                  break;
              }
          }
      } else {
          for (i in obj) {
              value = callback.apply(obj[i], args);

              if (value === false) {
                  break;
              }
          }
      }

      // A special, fast, case for the most common use of each
  } else {
      if (isArray) {
          for (; i < length; i++) {
              value = callback.call(obj[i], i, obj[i]);

              if (value === false) {
                  break;
              }
          }
      } else {
          for (i in obj) {
              value = callback.call(obj[i], i, obj[i]);

              if (value === false) {
                  break;
              }
          }
      }
  }

  return obj;
}

// core recursive function
// It removes keys that have null value and (TODO parses string keys (rows and cols) to int)
const filterNull = obj => {
  const result = obj
  if (typeof result === 'object') {
    each(result, function (key, value) {
      if (isNil(value)) {
        delete result[key]
      } else if (Object.prototype.toString.call(value) === '[object Object]') {
        filterNull(value)
      } else if (Array.isArray(value)) {
        value.forEach(function (el) { filterNull(el) })
      }
    })
  }
  return result
}

const filterEmptyStrings = obj => {
  const result = obj
  if (typeof result === 'object') {
    each(result, function (key, value) {
      if (typeof value === 'string' && value.length === 0) {
        delete result[key]
      } else if (typeof value === 'object'){
        filterEmptyStrings(value)
      }
    })
  }
  return result
}

const filterEmptyObjects = obj => {
  const result = obj
  if (typeof result === 'object') {
    each(result, function (key, value) {
      if (Array.isArray(value)) {
        value = value.filter(complement(either(isEmpty, isNil)))
      }

      if (isEmpty(value) || isNil(value)) {
        delete result[key]
      } else {
        filterEmptyObjects(value)
      }
    })
  }
  return result
}

const filterNullAndDeleteEmptyObjects = obj => {
  const afterNull = filterNull(obj)
  return filterEmptyObjects(afterNull)
}

export default {
  filterNull,
  filterEmptyStrings,
  filterNullAndDeleteEmptyObjects
}



// WEBPACK FOOTER //
// ./src/utils/preparePayload.js